import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import difference from 'lodash/difference';
import '../../styles/core.scss';
import css from './index.scss';
import { StudentManagement } from '../../helpers/icon-dictionary';
import EmptyState from '../../components/empty-state/index';


class DataGrid extends Component {
    static propTypes = {
        columns: PropTypes.array,
        handleGridSort: PropTypes.func,
        handleRowSelect: PropTypes.func,
        rowGetter: PropTypes.func,
        rowHeight: PropTypes.number,
        rowKey: PropTypes.string,
        rowRenderer: PropTypes.func,
        rowsCount: PropTypes.number,
        selectedRows: PropTypes.arrayOf(PropTypes.number),
        showSelectionColumn: PropTypes.bool
    };

    static defaultProps = {
        showSelectionColumn: true
    };

    constructor(props) {
        super(props);
        this.onRowsSelected = this.onRowsSelected.bind(this);
        this.onRowsDeselected = this.onRowsDeselected.bind(this);
    }

    onRowsSelected = (rows) => {
        const allSelectedRows = this.props.selectedRows.concat(rows.map(r => r.row[this.props.rowKey]));
        this.props.handleRowSelect(allSelectedRows);
        if (this.props.rowsCount > 0 && this.props.rowsCount === allSelectedRows.length) {
            const selectAllCheckBox = this.grid.getDataGridDOMNode().querySelector('#select-all-checkbox');
            selectAllCheckBox.checked = true;
        }
    };

    onRowsDeselected = (rows) => {
        const allSelectedRows = difference(this.props.selectedRows, rows.map(r => r.row[this.props.rowKey]));
        this.props.handleRowSelect(allSelectedRows);
        const selectAllCheckBox = this.grid.getDataGridDOMNode().querySelector('#select-all-checkbox');
        selectAllCheckBox.checked = false;
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedRows.length === 0) {
            // To handle the deselect event
            if (this.props.selectedRows.length > 1 || this.props.selectedRows.length === 0) {
                if (this.grid !== null && this.grid !== undefined) {
                    const gridCanvas = this.grid.getDataGridDOMNode().querySelector('.react-grid-Canvas');
                    gridCanvas.scrollTop = 0;
                }
            }
        }

        if (nextProps.rowsCount !== nextProps.selectedRows.length) {
            if (this.grid !== null && this.grid !== undefined) {
                const selectAllCheckBox = this.grid.getDataGridDOMNode().querySelector('#select-all-checkbox');
                if (selectAllCheckBox) {
                    selectAllCheckBox.checked = false;
                }
            }
        }
    }

    setGridReference(grid) {
        this.grid = grid;
        if (grid !== null && this.props.rowsCount > 0 && this.props.rowsCount === this.props.selectedRows.length) {
            const selectAllCheckBox = grid.getDataGridDOMNode().querySelector('#select-all-checkbox');
            if (selectAllCheckBox) {
                selectAllCheckBox.checked = true;
            }
        }
    }

    render() {
        const emptyStateView = <EmptyState iconName={StudentManagement} />;
        const gridView = this.props.showSelectionColumn ?
            (<ReactDataGrid
                columns={this.props.columns}
                enableRowSelect
                onGridSort={this.props.handleGridSort}
                overScan={{ colsStart: 17, colsEnd: 17, rowsStart: 25, rowsEnd: 100 }}
                ref={grid => this.setGridReference(grid)}
                rowGetter={this.props.rowGetter}
                rowHeight={this.props.rowHeight}
                rowKey={this.props.rowKey}
                rowRenderer={this.props.rowRenderer}
                rowsCount={this.props.rowsCount}
                rowSelection={{
                    showCheckbox: true,
                    onRowsSelected: this.onRowsSelected,
                    onRowsDeselected: this.onRowsDeselected,
                    selectBy: {
                        keys: { rowKey: this.props.rowKey, values: this.props.selectedRows }
                    }
                }}
            />) : (
                <ReactDataGrid
                    columns={this.props.columns}
                    overScan={{ colsStart: 17, colsEnd: 17, rowsStart: 25, rowsEnd: 100 }}
                    ref={grid => this.setGridReference(grid)}
                    rowGetter={this.props.rowGetter}
                    rowHeight={this.props.rowHeight}
                    rowKey={this.props.rowKey}
                    rowRenderer={this.props.rowRenderer}
                    rowsCount={this.props.rowsCount}
                />
            );

        const finalView = this.props.rowsCount === 0 ? emptyStateView : gridView;
        return (
            <div className={css.gridContainer}>
                {finalView}
            </div>);
    }
}

export default styleable(css)(DataGrid);



// WEBPACK FOOTER //
// ./app/components/data-grid/index.js